import { DatePipe } from "@angular/common"

export class FormatUtil {

    constructor() { }

    public static replaceUndefinedWithEmpty(val: any) {
        if (val == null || val == undefined) return ''
        return val
    }

    public static replaceEmptyWithNA(val: any) {
        if (val == null || val == undefined || val == '') return 'N/A'
        return val
    }

    public static replaceEmptyWithDashes(val: any) {
        if (val == null || val == undefined || val == '') return '--'
        return val
    }

    public static formatExternalLink(url: string) {
        return (url.indexOf('https://') == 0 || url.indexOf('http://') == 0) ? url : 'https://' + url
    }

    public static formatPhoneNumber(phoneNumber: string | undefined) {
        if (!phoneNumber)
            return null;
        var cleaned = ('' + phoneNumber).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return null;
    }

    public static formatName(first?: string, last?: string) {
        let names: string[] = []
        if (first) names.push(first)
        if (last) names.push(last)
        return this.replaceEmptyWithNA(names.join(' '));
    }

    public static getUTCNow() {
        const now = new Date();
        return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    }

    public static getDayAfter(dateString: string, datePipe: DatePipe, dayOverwite?: number,): string {
        let prevDateFormatted = new Date(dateString.indexOf('Z') == -1 ? dateString + 'Z' : dateString)
        prevDateFormatted.setDate((prevDateFormatted.getDate() + (dayOverwite ?? 1)));
        return datePipe.transform(FormatUtil.convertUtcToLocal(prevDateFormatted), 'yyyy-MM-dd') ?? '';
    }

    private static convertUtcToLocal(utcDate: Date): Date {
        return new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
    }

    public static formatDate(inputDate, format) {
        if (!inputDate) return '';

        const padZero = (value) => (value < 10 ? `0${value}` : `${value}`);
        const parts = {
            yyyy: inputDate.getFullYear(),
            MM: padZero(inputDate.getMonth() + 1),
            dd: padZero(inputDate.getDate()),
            HH: padZero(inputDate.getHours()),
            hh: padZero(inputDate.getHours() > 12 ? inputDate.getHours() - 12 : inputDate.getHours()),
            mm: padZero(inputDate.getMinutes()),
            ss: padZero(inputDate.getSeconds()),
            tt: inputDate.getHours() < 12 ? 'AM' : 'PM'
        };

        return format.replace(/yyyy|MM|dd|HH|hh|mm|ss|tt/g, (match) => parts[match]);
    }


    public static buildUtcDate(dateVal: string, timeVal: number): string {
        const timeStr = timeVal.toString().padStart(4, '0');
        const mins = timeStr.substring(timeStr.length - 2);
        const hrs = timeStr.substring(0, 2);
        const dateStr = `${dateVal}T${hrs}:${mins}:00`;
        return (new Date(dateStr)).toISOString();
    }

    public static buildDate(dateVal: string, timeVal: number): string {
        const timeStr = timeVal.toString().padStart(4, '0');
        const mins = timeStr.substring(timeStr.length - 2);
        const hrs = timeStr.substring(0, 2);
        const dateStr = `${dateVal}T${hrs}:${mins}:00`;
        return this.formatDate(new Date(dateStr), 'yyyy-MM-ddTHH:mm:ss');
    }

    public static buildDate2(date: Date): string {
        return this.formatDate(date, 'yyyy-MM-ddTHH:mm:ss');
    }

    public static convertTimeToUtc(dateVal: string, timeVal: number): number {
        const timeStr = timeVal.toString().padStart(4, '0');
        const mins = timeStr.substring(timeStr.length - 2);
        const hrs = timeStr.substring(0, 2);
        const dateStr = `${dateVal}T${hrs}:${mins}:00`;
        const utcDate = (new Date(dateStr)).toISOString();

        const utcTime = parseInt(utcDate.substring(11, 13)) * 100 + parseInt(utcDate.substring(14, 16));
        return utcTime;
    }

    public static capitalize(value: string): string {
        if (!value) return '';
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}